import React, { useContext, useEffect, useState } from 'react';
import { Animated } from 'react-animated-css';
import Modal from 'styled-react-modal'
import { AppContext } from '../contexts/AppContext';
import styled from "styled-components";
import Colors from '../helpers/Colors';
import Themes from '../styles/Themes';
import { useHistory } from 'react-router';
import Brightness3Icon from '@material-ui/icons/Brightness3';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { saveToStorage } from '../services/LocalStorage';

const StyledModal = Modal.styled`
width: 16rem;
height: 7rem;
display: flex;
align-items: center;
justify-content: center;
background-color: ${props => props.colorTheme.backgroundColor};
position: absolute;
left: calc(100% - 17rem);
top: 60px;
border-radius: 4.4px;
`;

const SettingText = styled.p`
font-size: 16.5px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.color};
display: flex;
flex: 1;
white-space: nowrap;
font-family: DINNextLTPro-Regular;
`;

const LogoutText = styled.p`
font-size: 16.5px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.color};
display: flex;
flex: 1;
white-space: nowrap;
font-family: DINNextLTPro-Regular;
`;

const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 45px;
  height: 20px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;

const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 45px;
  height: 20px;
  &:checked + ${CheckBoxLabel} {
    background: ${Colors.blue};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      margin-left: 28px;
      transition: 0.2s;
    }
  }
`;

const RowWrapperTop = styled.div`
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
text-align: center;
display: flex;
align-items: center;
`;

const RowWrapper = styled.div`
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
text-align: center;
display: flex;
align-items: center;
border-top: solid;
border-color: ${props => props.colorTheme.header.borderColor};
border-top-width: 1px;
`;

const Cell = styled.div`
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
display: flex;
flex: ${props => props.flex};
margin: 10px;
`;


const CheckBoxWrapper = styled.div`
  position: relative;
  flex: 1;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const Button = styled.button`
  color: ${Colors.white};
  background-color: ${Colors.blue};
  height: 45px;
  font-size: 18px;
  box-shadow: none;
  font-family: SFProDisplay-Medium;
  &:hover: {
      background-color: ${Colors.blue};
      box-shadow: none;
  };
  width: 100%;
`;

const IconDiv = styled.div`
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.colorTheme.header.fontColor};
flex: 1;
text-align: center;
display: inline;
background-color: ${props => props.backgroundColor};
height: 35px;
border-radius: 4px;
`;

export function Settings() {
    const history = useHistory();
    const { currentTheme, setCurrentTheme, settingsOpen, setSettingsOpen, setLoggedIn, setAuth, authData } = useContext(AppContext);

    const onClose = () => {
        setSettingsOpen(false);
    }

    const onLogoutClick = () => {
        setSettingsOpen(false);
        setLoggedIn(false);
        setAuth(undefined);
        localStorage.setItem('dashboard_user', '');
        localStorage.setItem('kitchen', '');
        history.replace("/login");
    }

    const onDarkModeChange = (event) => {
        if (event.target.checked) {
            setCurrentTheme(Themes.dark);
        } else {
            setCurrentTheme(Themes.light);
        }
    }

    useEffect(() => {
        if (!authData) {
            return;
        }
        saveToStorage(authData.username, { theme: currentTheme.name })
    }, [currentTheme]);

    return (
        <StyledModal
            colorTheme={currentTheme.dashboard}
            isOpen={settingsOpen}
            onBackgroundClick={onClose}
            onEscapeKeydown={onClose}
        >

            <Container>
                <RowWrapperTop colorTheme={currentTheme.dashboard}>
                    <Cell flex={5}>
                        <SettingText color={currentTheme.dashboard.row.fontColor}>
                            Dark Mode
                    </SettingText>
                    </Cell>
                    <Cell flex={2.2}>
                        <CheckBoxWrapper>
                            <CheckBox id="checkbox" type="checkbox" defaultChecked={currentTheme.name === 'dark'} onChange={onDarkModeChange} />
                            <CheckBoxLabel htmlFor="checkbox" />
                        </CheckBoxWrapper>
                    </Cell>
                    <Cell flex={2}>
                        <IconDiv backgroundColor={currentTheme.name === 'dark' ? '#242937' : '#f5f2f2'} colorTheme={currentTheme.dashboard}>
                            <Brightness3Icon style={{marginTop: '5px'}}></Brightness3Icon>
                        </IconDiv>
                    </Cell>
                </RowWrapperTop>

                <RowWrapper onClick={onLogoutClick} colorTheme={currentTheme.dashboard}>
                    <Cell flex={5}>
                        <LogoutText color={currentTheme.name === 'dark' ? '#ffffff' : '#be1a1a'}>
                            Log out
                    </LogoutText>
                    </Cell>
                    <Cell flex={2.2}>
                    </Cell>
                    <Cell flex={2}>
                    <IconDiv backgroundColor={currentTheme.name === 'dark' ? '#242937' : '#f5f2f2'} colorTheme={currentTheme.dashboard}>
                    <ExitToAppIcon style={{marginTop: '5px'}}></ExitToAppIcon>
                        </IconDiv>
                    </Cell>
                </RowWrapper>
            </Container>
        </StyledModal>
    );
}